<template>
    <div>
        <section class="section-title-page  container-fluid" style="background-image: url('/img/example.jpg');">
            <div class="container">
                <div class="wrapper">
                    <h1>Página <small style="font-weight: 300;">no encontrada</small></h1>
                    <span>
                        Volver <i class="fa fa-angle-right mx-1"></i>
                        <a href="">Inicio</a>
                    </span>
                </div>
            </div>
        </section>

        <section class="section-page container-fluid">
            <div class="container section-404">
                <i class="fa fa-face-frown"></i>
                <p>404</p>
                <p>Página no encontrada</p>
                <p>La página que busca no existe o se produjo otro error.
                    <br> Regrese o visite <a href="/" class="text-brown">{{ empresa.pagina_web }}</a>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
    name: 'MesaParteVirtual',
    computed: {
        ...mapState(['empresa']),
    },
    mounted() {
        document.title = "Pagina no encontrada..!";
    },
}
</script>

<style scoped>
.h-alt-hf {
    height: calc(100vh - 15.5625rem);
    width: 100%;
}

.fw-500 {
    font-weight: 500 !important;
}
</style>